module.exports = __webpack_public_path__ + "static/media/close-icon-menu.c5f607ae.svg";